// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/personalmain.css
// module id = 868
// module chunks = 41